import { PreviewModal } from "../components/PreviewModal"
import React from "react";

interface Props {}

export const OrangeFLPreview: React.FC<Props> = props => {
 return (<>
  <PreviewModal shape="16:9" playlistId={19445} onClose={() => {  }} />
 </>)
}